import React, { useMemo, useRef } from "react";

import { DarkThemeSingleSelect } from "../../../../components";
import { useAppSelector } from "../../../../redux/hooks";
import { selectOrg } from "../../../../redux/slices/orgSlice";
import { getRebootLiveMovementTypeOptions } from "../../constants";
import { IncludeInverseKinematicsCheckbox } from "../shared/IncludeInverseKinematicsCheckbox";
import { getFreeformSelectStyles } from "../shared/rebootLiveSelectStyles";

interface MovementTypeStepProps {
  selectedMovementType: string;
  onMovementTypeChange: (movementType: string) => void;
  includeInverseKinematics?: boolean;
  onIncludeInverseKinematicsChange?: (include: boolean) => void;
}

export const MovementTypeStep: React.FC<MovementTypeStepProps> = ({
  selectedMovementType,
  onMovementTypeChange,
  includeInverseKinematics,
  onIncludeInverseKinematicsChange,
}) => {
  const org = useAppSelector(selectOrg);
  const containerRef = useRef<HTMLDivElement>(null);

  const movementTypeOptions = getRebootLiveMovementTypeOptions(
    org.details.movementTypes,
  );

  const movementTypeSelectStyles = useMemo(
    () => getFreeformSelectStyles({ includeOptionOverrides: false }),
    [],
  );

  return (
    <div className="box-border content-stretch flex flex-col gap-[24px] items-center pb-0 pt-[12px] px-0 relative shrink-0 w-full max-w-[960px]">
      <p
        data-testid="reboot-live-movement-type-prompt"
        className="font-medium leading-[23px] not-italic relative shrink-0 text-[18px] text-center text-white"
      >
        What type of movement should we study?
      </p>
      <div
        ref={containerRef}
        data-testid="reboot-live-movement-type-container"
        className="bg-[#1d1d1f] relative rounded-[12px] shrink-0 w-[600px] overflow-visible"
      >
        <div className="bg-clip-padding border-0 border-transparent border-solid box-border content-stretch flex flex-col h-full items-start pb-[32px] pt-[32px] px-[32px] relative w-[600px]">
          <div className="w-full">
            <DarkThemeSingleSelect
              value={selectedMovementType}
              onChange={onMovementTypeChange}
              options={movementTypeOptions}
              placeholder="Select a movement type..."
              styles={movementTypeSelectStyles}
              className="w-full"
              classNamePrefix="reboot-live-movement-type-select"
              onMenuOpen={() => {
                containerRef.current?.scrollIntoView({
                  block: "start",
                  behavior: "smooth",
                });
              }}
            />
          </div>
        </div>
      </div>
      {onIncludeInverseKinematicsChange && (
        <IncludeInverseKinematicsCheckbox
          checked={includeInverseKinematics ?? false}
          onChange={onIncludeInverseKinematicsChange}
          className="flex items-center gap-[10px] w-[600px] cursor-pointer"
          labelTextClassName="text-[14px] text-white"
        />
      )}
    </div>
  );
};
